import { UserAdminOutput } from 'dtos/users/UserAdminOutput';
import { UserListOutput } from 'dtos/users/UserListOutput';
import { makeAutoObservable, runInAction } from 'mobx';
import { AuthStore } from 'stores/users/AuthStore';
import { Match } from 'navigo';
import { serverUri } from 'utils/config';
import { nullsToUndefined } from 'utils/nullsToUndefined';

export class UserListStore {
  users: UserAdminOutput[] = [];

  constructor(private readonly authStore: AuthStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async activate(match: Match) {
    await this.getUsers();
  }

  async getUsers() {
    try {
      const response = await this.authStore.fetchWithAuth(`${serverUri}/admin/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error('Error getting users');
      const { users }: UserListOutput = nullsToUndefined(await response.json());
      runInAction(() => {
        this.users = users.sort((user1, user2) => user1.username.localeCompare(user2.username));
      });
    } catch (err) {
      runInAction(() => {
        this.users = [];
      });
    }
  }

  async deleteUser(user: UserAdminOutput) {
    try {
      const response = await this.authStore.fetchWithAuth(
        `${serverUri}/admin/users/${encodeURIComponent(user.username)}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      if (!response.ok) throw new Error('Error deleting user');
      await this.getUsers();
    } catch (err) {}
  }
}
